var _circle, _g, _circle2, _circle3, _circle4, _circle5, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataAlternate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 152,
    viewBox: "0 0 193 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.1682,
    cy: 65.6436,
    r: 65.6436,
    fill: "#FDA504"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_22983_78595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1882 20.1982C84.589 20.1982 72.5592 26.9182 65.2385 37.2187C62.8479 36.655 60.3549 36.3567 57.7922 36.3567C39.9441 36.3567 25.4753 50.8254 25.4753 68.6735C25.4753 86.5216 39.9441 100.99 57.7922 100.99L138.584 100.99C154.201 100.99 166.861 88.3302 166.861 72.7131C166.861 57.096 154.201 44.4359 138.584 44.4359C137.475 44.4359 136.381 44.4997 135.305 44.624C129.114 30.2565 114.826 20.1982 98.1882 20.1982Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.7922,
    cy: 68.6728,
    r: 32.3168,
    fill: "url(#paint0_linear_22983_78595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.1883,
    cy: 60.5943,
    r: 40.396,
    fill: "url(#paint1_linear_22983_78595)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.584,
    cy: 72.7133,
    rx: 28.2772,
    ry: 28.2772,
    fill: "url(#paint2_linear_22983_78595)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7377,
    cy: 23.9852,
    r: 6.31188,
    fill: "#58C0BF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9504,
    cy: 137.599,
    r: 8.83663,
    fill: "#58C0BF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.272,
    cy: 44.1833,
    r: 8.83663,
    fill: "#58C0BF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.386,
    cy: 10.0988,
    r: 5.0495,
    fill: "#58C0BF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_22983_78595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.8713,
    y: 78.2671,
    width: 60.5941,
    height: 60.5941,
    rx: 30.297,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.53 119.926L102.038 114.435M105.005 107.302C105.005 112.88 100.483 117.401 94.9059 117.401C89.3284 117.401 84.8069 112.88 84.8069 107.302C84.8069 101.725 89.3284 97.2031 94.9059 97.2031C100.483 97.2031 105.005 101.725 105.005 107.302Z",
    stroke: "white",
    strokeWidth: 2.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_22983_78595",
    x: 0.227819,
    y: 20.1982,
    width: 191.881,
    height: 131.288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.0495,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_22983_78595"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.099
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.0495
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22983_78595"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.0495,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_22983_78595"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25.2475
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.1485
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_22983_78595",
    result: "effect2_dropShadow_22983_78595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_22983_78595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_22983_78595",
    x: 55.7723,
    y: 68.1681,
    width: 80.792,
    height: 80.7923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.0495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_22983_78595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_22983_78595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22983_78595",
    x1: 32.9775,
    y1: 47.3206,
    x2: 90.109,
    y2: 100.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22983_78595",
    x1: 67.1699,
    y1: 33.904,
    x2: 138.584,
    y2: 100.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22983_78595",
    x1: 116.871,
    y1: 54.0301,
    x2: 166.861,
    y2: 100.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAlternate);
export default __webpack_public_path__ + "static/media/noDataAlternate.7b2ae154cd47a5c565ef052c36986532.svg";
export { ForwardRef as ReactComponent };